import React, { useState, useEffect, useRef, useCallback } from "react";
import "../horoscope/daily.css";
import APIURL from "../../common/Config";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../header/header";
import Footer from "../footer/footer";

const DailyHoroscope = () => {
  const navigate = useNavigate();
  const { sign: paramSign = "gemini", day: paramDay = "today" } = useParams();

  const formatSignName = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  const [selectedSign, setSelectedSign] = useState(() => formatSignName(paramSign));
  const [horoscopeData, setHoroscopeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeButton, setActiveButton] = useState(() => paramDay);

  const inMemoryCacheRef = useRef(new Map());

  const getDateFromDay = (dayStr) => {
    const today = new Date();
    const newDate = new Date(today); 
    if (dayStr === "yesterday") return new Date(newDate.setDate(today.getDate() - 1));
    if (dayStr === "tomorrow") return new Date(newDate.setDate(today.getDate() + 1));
    return new Date(today); 
  };

  const [selectedDate, setSelectedDate] = useState(() => getDateFromDay(paramDay));

  const formatDate = (dateNum) => {
    const dateStr = dateNum.toString();
    return `${dateStr.slice(6, 8)}-${dateStr.slice(4, 6)}-${dateStr.slice(
      0,
      4
    )}`;
  };

  const getDateString = (date) =>
    date.toISOString().slice(0, 10).replace(/-/g, "");

  
  const metaDataBySign = {
    Aries: {
      title: "AstroBhagya - Aries free Daily Horoscope by Best Astrologer",
      description:
        "Read your Aries free daily horoscope for today's love, career, and health insights. Accurate Aries horoscope predictions for the fiery Aries zodiac sign.",
      keywords:
        "Aries Free Daily Horoscope, Aries Horoscope today, Aries zodiac sign, Aries horoscope predictions",
    },
    Taurus: {
      title: "AstroBhagya - Taurus free Daily Horoscope by Best Astrologer",
      description:
        "Read your Taurus free daily horoscope for today's love, career, and health insights. Accurate Taurus horoscope predictions for the steady Taurus zodiac sign.",
      keywords:
        "Taurus Free Daily Horoscope, Taurus Horoscope today, Taurus zodiac sign, Taurus horoscope predictions",
    },
    Gemini: {
      title: "AstroBhagya - Gemini free Daily Horoscope by Best Astrologer",
      description:
        "Read your Gemini free daily horoscope for today's love, career, and health insights. Accurate Gemini horoscope predictions for the steady Gemini zodiac sign.",
      keywords:
        "Gemini Free Daily Horoscope, Gemini Horoscope today, Gemini zodiac sign, Gemini horoscope predictions",
    },
    Cancer: {
      title: "AstroBhagya - Cancer free Daily Horoscope by Best Astrologer",
      description:
        "Read your Cancer free daily horoscope for today's love, career, and health insights. Accurate Cancer horoscope predictions for the emotional Cancer zodiac sign.",
      keywords:
        "Cancer Free Daily Horoscope, Cancer Horoscope today, Cancer zodiac sign, Cancer horoscope predictions",
    },
    Leo: {
      title: "AstroBhagya - Leo free Daily Horoscope by Best Astrologer",
      description:
        "Read your Leo free daily horoscope for today's love, career, and health insights. Accurate Leo horoscope predictions for the bold Leo zodiac sign.",
      keywords:
        "Leo Free Daily Horoscope, Leo Horoscope today, Leo zodiac sign, Leo horoscope predictions",
    },
    Virgo: {
      title: "AstroBhagya - Virgo free Daily Horoscope by Best Astrologer",
      description:
        "Read your Virgo free daily horoscope for today's love, career, and health insights. Accurate Virgo horoscope predictions for the practical Virgo zodiac sign.",
      keywords:
        "Virgo Free Daily Horoscope, Virgo Horoscope today, Virgo zodiac sign, Virgo horoscope predictions",
    },
    Libra: {
      title: "AstroBhagya - Libra free Daily Horoscope by Best Astrologer",
      description:
        "Read your Libra free daily horoscope for today's love, career, and health insights. Accurate Libra horoscope predictions for the balanced Libra zodiac sign.",
      keywords:
        "Libra Free Daily Horoscope, Libra Horoscope today, Libra zodiac sign, Libra horoscope predictions",
    },
    Scorpio: {
      title: "AstroBhagya - Scorpio free Daily Horoscope by Best Astrologer",
      description:
        "Read your Scorpio free daily horoscope for today's love, career, and health insights. Accurate Scorpio horoscope predictions for the intense Scorpio zodiac sign.",
      keywords:
        "Scorpio Free Daily Horoscope, Scorpio Horoscope today, Scorpio zodiac sign, Scorpio horoscope predictions",
    },
    Sagittarius: {
      title: "AstroBhagya - Sagittarius free Daily Horoscope by Best Astrologer",
      description:
        "Read your Sagittarius free daily horoscope for today's love, career, and health insights. Accurate Sagittarius horoscope predictions for the adventurous Sagittarius zodiac sign.",
      keywords:
        "Sagittarius Free Daily Horoscope, Sagittarius Horoscope today, Sagittarius zodiac sign, Sagittarius horoscope predictions",
    },
    Capricorn: {
      title: "AstroBhagya - Capricorn free Daily Horoscope by Best Astrologer",
      description:
        "Read your Capricorn free daily horoscope for today's love, career, and health insights. Accurate Capricorn horoscope predictions for the ambitious Capricorn zodiac sign.",
      keywords:
        "Capricorn Free Daily Horoscope, Capricorn Horoscope today, Capricorn zodiac sign, Capricorn horoscope predictions",
    },
    Aquarius: {
      title: "AstroBhagya - Aquarius free Daily Horoscope by Best Astrologer",
      description:
        "Read your Aquarius free daily horoscope for today's love, career, and health insights. Accurate Aquarius horoscope predictions for the innovative Aquarius zodiac sign.",
      keywords:
        "Aquarius Free Daily Horoscope, Aquarius Horoscope today, Aquarius zodiac sign, Aquarius horoscope predictions",
    },
    Pisces: {
      title: "AstroBhagya - Pisces free Daily Horoscope by Best Astrologer",
      description:
        "Read your Pisces free daily horoscope for today's love, career, and health insights. Accurate Pisces horoscope predictions for the dreamy Pisces zodiac sign.",
      keywords:
        "Pisces Free Daily Horoscope, Pisces Horoscope today, Pisces zodiac sign, Pisces horoscope predictions",
    },
  };
  

  const fetchHoroscope = useCallback(async (date, retries = 3) => {
    const dateStr = getDateString(date);
    setError(null);
    setLoading(true);

    const localStorageKey = `horoscope_data_${dateStr}`;
    const cachedLocalStorageData = localStorage.getItem(localStorageKey);
    if (cachedLocalStorageData) {
      try {
        const parsedData = JSON.parse(cachedLocalStorageData);
        setHoroscopeData(parsedData);
        setLoading(false);
        console.log("Horoscope data loaded from localStorage.");
        return;
      } catch (e) {
        console.error("Failed to parse cached data from local storage, fetching new data:", e);
      }
    }

    if (inMemoryCacheRef.current.has(dateStr)) {
      setHoroscopeData(inMemoryCacheRef.current.get(dateStr));
      setLoading(false);
      console.log("Horoscope data loaded from in-memory cache.");
      return;
    }

    const minLoadingTime = new Promise(resolve => setTimeout(resolve, 500)); 

    try {
      const controller = new AbortController();
      const id = setTimeout(() => {
        controller.abort();
        console.warn('Fetch request timed out after 15 seconds.');
      }, 15000);

      const response = await fetch(
        `${APIURL}/horroscope/getallprediction?type=daily&startDate=${dateStr}&endDate=${dateStr}&language=english`,
        { signal: controller.signal }
      );

      clearTimeout(id);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (Array.isArray(data)) {
        inMemoryCacheRef.current.set(dateStr, data);
        localStorage.setItem(localStorageKey, JSON.stringify(data));
        setHoroscopeData(data);
        console.log("Horoscope data fetched successfully from API and cached.");
      } else {
        throw new Error("Unexpected response format from API.");
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        setError('The network request timed out. Please check your internet connection and try again.');
        console.error("Network timeout error:", error);
      } else {
        setError(`Failed to load horoscope data: ${error.message}. Please try again.`);
        console.error("Error fetching horoscope data:", error);
      }

      if (retries > 0) {
        console.log(`Retrying fetch for ${dateStr}. Retries left: ${retries - 1}`);
        await new Promise(resolve => setTimeout(resolve, 3000));
        return fetchHoroscope(date, retries - 1);
      } else {
        setHoroscopeData([]);
        console.log("All retries exhausted. Data could not be loaded.");
      }
    } finally {
      await minLoadingTime;
      setLoading(false);
    }
  }, []);

 
  useEffect(() => {
    fetchHoroscope(selectedDate);
  }, [selectedDate, fetchHoroscope]);

 
  useEffect(() => {
   
    const newFormattedSign = formatSignName(paramSign);
    if (selectedSign !== newFormattedSign) {
        setSelectedSign(newFormattedSign);
    }

    
    if (activeButton !== paramDay) {
        setActiveButton(paramDay);
    }
    
    
    const newDateFromParam = getDateFromDay(paramDay);
    if (selectedDate.toDateString() !== newDateFromParam.toDateString()) {
        setSelectedDate(newDateFromParam);
    }
  }, [paramSign, paramDay]); 

 
  useEffect(() => {
    const currentPath = `/daily-horoscope/${activeButton}/${selectedSign.toLowerCase()}`;
    
    if (window.location.pathname !== currentPath) {
        navigate(currentPath, { replace: true });
    }
  }, [selectedSign, activeButton, navigate]);

  
  useEffect(() => {
    const setOrCreateMetaTag = (name, content, isProperty = false) => {
      let metaTag = document.querySelector(
        isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`
      );
      if (metaTag) {
        metaTag.setAttribute("content", content);
      } else {
        metaTag = document.createElement("meta");
        if (isProperty) {
          metaTag.setAttribute("property", name);
        } else {
          metaTag.setAttribute("name", name);
        }
        metaTag.setAttribute("content", content);
        document.head.appendChild(metaTag);
      }
    };

    const currentMetaData = metaDataBySign[selectedSign] || {};

    document.title = currentMetaData.title || "Daily Horoscope | AstroBhagya";

    setOrCreateMetaTag("description", currentMetaData.description || "");
    setOrCreateMetaTag("keywords", currentMetaData.keywords || "");
    setOrCreateMetaTag("author", "Heavenly Expectation Private Limited");
    setOrCreateMetaTag("revisit-after", "7 days");
    setOrCreateMetaTag("distribution", "global");
    setOrCreateMetaTag("rating", "general");

    setOrCreateMetaTag("og:title", currentMetaData.title || "Daily Horoscope | AstroBhagya", true);
    setOrCreateMetaTag("og:description", currentMetaData.description || "", true);
    setOrCreateMetaTag("og:type", "website", true);
    setOrCreateMetaTag("og:url", window.location.href, true);
   


    let charsetMeta = document.querySelector("meta[charset]");
    if (!charsetMeta) {
      charsetMeta = document.createElement("meta");
      charsetMeta.setAttribute("charset", "UTF-8");
      document.head.prepend(charsetMeta);
    }
  }, [selectedSign, metaDataBySign]);

  
  const handleDateChange = (days, button) => {
    const newDate = new Date(); 
    newDate.setDate(newDate.getDate() + days); 

    
    setSelectedDate(newDate);
    setActiveButton(button);
  };

 
  const handleSignChange = (newSign) => {
   
    setSelectedSign(newSign);
  };

  const toggleAnswer = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const signImages = {
    Aries: require("../../assets/Ariesss.webp"),
    Taurus: require("../../assets/Taurusss.webp"),
    Gemini: require("../../assets/Geminiii.webp"),
    Cancer: require("../../assets/Cancerrr.webp"),
    Leo: require("../../assets/Leooo.webp"),
    Virgo: require("../../assets/Virgooo.webp"),
    Libra: require("../../assets/Libraaa.webp"),
    Scorpio: require("../../assets/Scorpiooo.webp"),
    Sagittarius: require("../../assets/Sagittariusss.webp"),
    Capricorn: require("../../assets/Capricornnn.webp"),
    Aquarius: require("../../assets/Aqauriusss.webp"),
    Pisces: require("../../assets/Piscesss.webp"),
  };

  const prediction = horoscopeData.find(
    (item) => item.sunShine.toUpperCase() === selectedSign.toUpperCase()
  ) || { prediction: "Horoscope data not available for this sign or date. Please try refreshing or checking your internet connection.", startDate: null };

  const displayDate =
    prediction && prediction.startDate
      ? formatDate(prediction.startDate)
      : "N/A";

  const getTitle = () => {
    const today = new Date().toDateString();
    const selected = selectedDate.toDateString();
    const yesterday = new Date(
      new Date().setDate(new Date().getDate() - 1)
    ).toDateString();
    const tomorrow = new Date(
      new Date().setDate(new Date().getDate() + 1)
    ).toDateString();

    if (selected === today) return "Your horoscope for today";
    if (selected === yesterday) return "Missed a day? Catch up here";
    if (selected === tomorrow) return "See what's ahead for you";
    return `Horoscope for ${selectedSign}`;
  };

  const handleYearlyClick = () => navigate(`/yearly-horoscope`);

  const title = getTitle();

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner" />
        <p>Loading your horoscope...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <p>{error}</p>
        <button className="retry-button" onClick={() => fetchHoroscope(selectedDate)}>Retry</button>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="horoscope-container-fluid">
        <div className="horoscope-container">
          <div className="horoscope-content">
            <h2 className="horoscope-title">{title}</h2>
            <div className="horoscope-image">
              <img src={signImages[selectedSign]} alt={selectedSign} />
            </div>
            <div className="horoscope-date">{displayDate}</div>
            <p className="horoscope-text">
              {prediction.prediction.replace(/\s+/g, " ").trim()}
            </p>
          </div>

          <div className="horoscope-sidebar">
            <label className="dropdown-label">Choose a Different Sign</label>
            <select
              className="sign-dropdown"
              value={selectedSign}
              onChange={(e) => handleSignChange(e.target.value)}
            >
              {Object.keys(signImages).map((sign) => (
                <option key={sign} value={sign}>
                  {sign}
                </option>
              ))}
            </select>

            <button className="discover-button">
              Discover More Horoscopes
            </button>

            <div className="navigation-links">
              <ul>
                <li>
                  <button
                    className={`horobtn ${
                      activeButton === "yesterday" ? "active" : ""
                    }`}
                    onClick={() => handleDateChange(-1, "yesterday")}
                  >
                    Yesterday
                  </button>
                </li>
                <li>
                  <button
                    className={`horobtn ${
                      activeButton === "today" ? "active" : ""
                    }`}
                    onClick={() => handleDateChange(0, "today")}
                  >
                    Today
                  </button>
                </li>
                <li>
                  <button
                    className={`horobtn ${
                      activeButton === "tomorrow" ? "active" : ""
                    }`}
                    onClick={() => handleDateChange(1, "tomorrow")}
                  >
                    Tomorrow
                  </button>
                </li>
                <li>
                  <button className="horobtn" onClick={handleYearlyClick}>
                    Yearly
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

     
        <div className="faq-section">
          <div className="container-item">
            <h3>Frequently Asked Questions (FAQs) – Daily Horoscope</h3>
            <div className="fitem">
              {[
                {
                  question: "1. What is a daily horoscope?",
                  answer:
                    "A daily horoscope is an astrological forecast based on planetary movements, offering insights into various aspects of life such as career, relationships, health, and finances.",
                },
                {
                  question: "2. How reliable are daily horoscopes?",
                  answer:
                    "Daily horoscopes provide general guidance based on sun signs and celestial alignments.",
                },
                {
                  question: "3. Can a horoscope predict my future?",
                  answer:
                    "Horoscopes provide insights into potential trends, influences, and energies based on your astrological sign. While they do not offer absolute predictions, they serve as a guide to help you understand and navigate life's opportunities.",
                },
                {
                  question:
                    "4. Why do different sources offer varying horoscopes for the same sign?",
                  answer:
                    "Astrologers use different methods and interpretations, leading to slight variations in predictions.",
                },
                {
                  question: "5. Should I read my horoscope every day?",
                  answer:
                    "That's entirely up to you! Some find daily horoscopes useful for guidance, while others prefer weekly or monthly insights.",
                },
                {
                  question: "6. How is my daily horoscope determined?",
                  answer:
                    "Your horoscope is calculated based on the positioning of the sun, moon, and planets in relation to your zodiac sign.",
                },
                {
                  question: "7. Can horoscopes assist with decision-making?",
                  answer:
                    "Horoscopes offer insights into favourable and challenging periods but should complement your judgment.",
                },
                {
                  question:
                    "8. Should I read my sun sign or moon sign horoscope?",
                  answer:
                    "Daily horoscopes are typically based on your sun sign.",
                },
                {
                  question: "9. Can horoscopes influence my mood?",
                  answer:
                  "Yes, many people find encouragement in their horoscopes.",
                },
                {
                  question:
                    "10. Where can I find my daily horoscope on AstroBhagya?",
                  answer:
                    "You can access your daily horoscope on AstroBhagya's Daily Horoscope Page.",
                },
              ].map((item, index) => (
                <div className="faq-item" key={index}>
                  <div
                    className={`faq-question ${
                      activeIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleAnswer(index)}
                  >
                    {item.question}
                  </div>
                  <div
                    className={`faq-answer ${
                      activeIndex === index ? "show" : ""
                    }`}
                  >
                    {item.answer}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DailyHoroscope; 